import eventSenderMixin from './io/eventSenderMixin'
import calendarSenderMixin from './io/calendarSenderMixin'

export default {
  mixins: [eventSenderMixin, calendarSenderMixin],
  emits: ['deleted', 'view'],
  methods: {
    async baseSetStatus (id, val, successCallback = () => {}, doneCallback = () => {}, errorCallback = () => {}) {
      const { status, errors } = await this.$put('v1/appointments/status', {
        id,
        status: val
      })
      doneCallback()
      if (status === 'success') {
        const sendPayload = {
          id,
          status: val
        }

        this.$bus.emit('calendar:status', sendPayload)
        this.ioCalendarStatus(sendPayload)
        this.ioEventStatus(sendPayload)
        this.$q.notify({
          color: 'green',
          message: 'Appointment status successfully changed.'
        })
        successCallback()
      }
      else {
        // Check if error is due to missing required forms
        if (errors && errors.missing_forms && errors.missing_forms.length > 0) {
          const formNames = errors.missing_forms.map(f => f.title).join(', ')
          this.$q.notify({
            color: 'orange-7',
            message: 'Cannot complete appointment. Required forms not submitted: ' + formNames,
            timeout: 5000,
            actions: [{ icon: 'close', color: 'white' }]
          })
        }
        // Check if error is due to missing required checklist items
        if (errors && errors.missing_checklist_items && errors.missing_checklist_items.length > 0) {
          const itemNames = errors.missing_checklist_items.map(i => i.text).join(', ')
          this.$q.notify({
            color: 'orange-7',
            message: 'Cannot complete appointment. Required checklist items not completed: ' + itemNames,
            timeout: 5000,
            actions: [{ icon: 'close', color: 'white' }]
          })
        }
        errorCallback()
      }
    },
    async baseDeleteAppointment (id, deleteAction = 'none', successCallback = () => {}) {
      this.$loading.show({
        message: 'Deleting Appointment...'
      })
      const { status, payload } = await this.$remove('v1/appointments', {
        id,
        delete_action: deleteAction
      })
      this.$loading.hide()
      if (status === 'success') {
        this.$bus.emit('calendar:remove', payload.deleted_ids)
        this.ioCalendarRemove(payload.deleted_ids)
        this.ioEventRemove(payload.deleted_ids)
        this.$q.notify({
          color: 'green',
          message: 'Appointment successfully deleted.'
        })
        this.$emit('deleted')
      }
      successCallback()
    },
    async baseMarkAsUnscheduled (id) {
      this.$loading.show({
        message: 'Marking Appointment as unscheduled...'
      })
      const { status, payload } = await this.$post('v1/appointments/unscheduled/mark', {
        id
      })
      this.$loading.hide()
      if (status === 'success') {
        this.$bus.emit('calendar:remove', [parseInt(id)])
        this.ioCalendarUnscheduled([id])
        this.ioEventUpdate(id)
        setTimeout(() => {
          this.$bus.emit('calendar:unscheduled:add', payload.appointment)
        }, 250)
        this.$q.notify({
          color: 'green',
          message: 'Appointment successfully marked as unscheduled.'
        })
      }
    },
    baseOpenAppointment (id) {
      this.$bus.emit('calendar:open', parseInt(id))
      this.$emit('view')
    },
    /**
     * Update the invoiced status of an appointment.
     * @param {number} id - Appointment ID
     * @param {boolean|null} invoicedStatus - true for invoiced, false for not invoiced, null for auto-detect
     */
    async baseSetInvoicedStatus (id, invoicedStatus, successCallback = () => {}) {
      const { status, payload } = await this.$put('v1/appointments/invoiced-status', {
        id,
        invoiced_status: invoicedStatus
      })
      if (status === 'success') {
        const sendPayload = {
          id,
          isInvoiced: payload.is_invoiced,
          isInvoicedManual: payload.is_invoiced_manual
        }

        this.$bus.emit('calendar:invoicedStatus', sendPayload)
        this.ioEventUpdate(id)
        this.$q.notify({
          color: 'green',
          message: 'Invoiced status successfully updated.'
        })
        successCallback(payload)
      }
    },
    /**
     * Update the paid status of an appointment.
     * @param {number} id - Appointment ID
     * @param {boolean|null} paidStatus - true for paid, false for not paid, null for auto-detect
     */
    async baseSetPaidStatus (id, paidStatus, successCallback = () => {}) {
      const { status, payload } = await this.$put('v1/appointments/paid-status', {
        id,
        paid_status: paidStatus
      })
      if (status === 'success') {
        const sendPayload = {
          id,
          isPaid: payload.is_paid,
          isPaidManual: payload.is_paid_manual
        }

        this.$bus.emit('calendar:paidStatus', sendPayload)
        this.ioEventUpdate(id)
        this.$q.notify({
          color: 'green',
          message: 'Payment status successfully updated.'
        })
        successCallback(payload)
      }
    }
  }
}
